export default __webpack_public_path__ + "static/media/slide-5.580cb851.jpg";